function parse(obj) {
  try {
    return JSON.parse(obj);
  } catch (error) {
    return undefined;
  }
}

export default parse;
